import ApiService from './api.service'

const TagService = {
  attach (data) {
    return ApiService.postWithoutLoading('api/v2/admin/tags/attach', data)
  }
}

export default TagService
